import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Conditional } from '@resurs/react-utils'
import { Columns, Column, Select } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'
import { CustomerTypeModel } from '../../models/private-models'

const CardSelector = ({
  card,
  availableCards,
  onCardSelected,
  customerType,
}) => {
  const groupBy4 = value => {
    return value.match(/.{1,4}/g).join(' ')
  }

  const makeItem = (text, value, id) => {
    return (
      <div
        id={id}
        style={{
          paddingTop: '1rem',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {`${getText(text)}: `}
        <NumberFormat
          value={Math.floor(value)}
          displayType="text"
          thousandSeparator=" "
          renderText={val => getText('default.currency', val)}
        />
      </div>
    )
  }
  if (card) {
    return (
      <Columns>
        <Column col6 colMd12>
          <Conditional
            when={
              customerType === CustomerTypeModel.NATURAL &&
              availableCards.length > 1
            }
          >
            <Select
              id="available-cards"
              label={getText('payApply.paymentMethod.cards')}
              values={availableCards}
              onChange={value => onCardSelected(value)}
            />
          </Conditional>
          <Conditional when={customerType === CustomerTypeModel.LEGAL}>
            <label key="labelCardAccount" className={midas.formLabel}>
              {getText('payApply.paymentMethod.cards')}
            </label>
            <div key="existingNumberFormat" style={{ paddingTop: '1rem' }}>
              <span style={{ fontSize: '2rem' }}>
                <NumberFormat
                  value={
                    card.existingNumber.slice(0, 4) +
                    card.existingNumber.slice(12, 16)
                  }
                  displayType="text"
                />
              </span>
            </div>
          </Conditional>
          <Conditional
            when={
              customerType === CustomerTypeModel.NATURAL &&
              availableCards.length <= 1
            }
          >
            <label key="labelCardAccount" className={midas.formLabel}>
              {getText('payApply.paymentMethod.cards')}
            </label>
            <div key="existingNumberFormat" style={{ paddingTop: '1rem' }}>
              <span style={{ fontSize: '2rem' }}>
                {groupBy4(card.existingNumber)}
              </span>
            </div>
          </Conditional>
        </Column>
        <Column col6 colMd12 />
        <Column col6 colMd12>
          <div style={{ paddingTop: '1rem' }}>
            {makeItem(
              'payApply.paymentMethod.approvedCredit',
              card.approvedCredit,
              'approved-credit-amount',
            )}
            {makeItem(
              'payApply.paymentMethod.usedCredit',
              card.approvedCredit - card.usableAmount,
              'used-credit-amount',
            )}
            <b>
              {makeItem(
                'payApply.paymentMethod.currentCredit',
                card.usableAmount,
                'current-credit-amount',
              )}
            </b>
          </div>
        </Column>
      </Columns>
    )
  }
  return null
}

CardSelector.propTypes = {
  card: PropTypes.object.isRequired,
  availableCards: PropTypes.array.isRequired,
  onCardSelected: PropTypes.func.isRequired,
  customerType: PropTypes.string.isRequired,
}

export default CardSelector
